class SectionFilterForm extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest('.container');
    this.onFilterChange = this.onFilterChange.bind(this);
    this.form = this.querySelector('form');
    this.sections = document.querySelectorAll('.products-grid[data-tag]');

    this.form.addEventListener('input', this.onFilterChange);

    this.querySelectorAll('.facets__reset').forEach((btn) =>
      btn.addEventListener('click', (e) => this.resetFilters(e, btn))
    );

    const btnShow = this.querySelector('.facets__button-show');
    const closeBtn = this.querySelector('.facets__close');
    const wrapperEl = this.querySelector('.facets__wrapper');
    const collection = this.closest('.collection-wrapper');

    if (btnShow) {
      btnShow.onclick = () => {
        wrapperEl.classList.add('active');
        collection.querySelector('.facets-container').classList.add('active');
        document.body.classList.add('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.removeAttribute('tabindex'));
      };
    }

    if (closeBtn) {
      closeBtn.onclick = () => {
        wrapperEl.classList.remove('active');
        collection.querySelector('.facets-container').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.setAttribute('tabindex', '-1'));
      };
    }

    window.addEventListener('keyup', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        wrapperEl.classList.remove('active');
        collection.querySelector('.facets-container').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        wrapperEl.querySelectorAll('details, a, input, button').forEach((e) => e.setAttribute('tabindex', '-1'));
      }
    });
  }

  getSelectedTags() {
    const groups = {};

    const inputs = this.form.querySelectorAll('input[type="checkbox"]:checked');
    inputs.forEach((input) => {
      const group = input.name;
      if (!groups[group]) groups[group] = [];
      groups[group].push(...input.value.split(',').map((t) => t.trim()));
    });

    return Object.values(groups).map((tags) => [...new Set(tags)]);
  }

  onFilterChange() {
    const selectedGroups = this.getSelectedTags();

    if (selectedGroups.length === 0) {
      this.showAllSections();
      return;
    }

    let visibleCount = 0;

    this.sections.forEach((section) => {
      const sectionTags = section.dataset.tag.split(',').map((t) => t.trim());

      const match = selectedGroups.every((group) => group.some((tag) => sectionTags.includes(tag)));

      section.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    this.toggleZeroContainer(visibleCount !== 0);
  }

  toggleZeroContainer(enable) {
    if (!this.container) return;
    this.container.classList.toggle('container--zero', enable);
  }

  showAllSections() {
    this.sections.forEach((section) => (section.style.display = ''));
    this.toggleZeroContainer(true);
  }

  resetFilters(e, btn) {
    e.preventDefault();

    const group = btn.closest('details');
    if (!group) return;

    const inputs = group.querySelectorAll('input[type="checkbox"]');
    inputs.forEach((input) => (input.checked = false));

    this.onFilterChange();
  }
}

customElements.define('section-filter-form', SectionFilterForm);

class SectionFacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('button');
    if (!link) return;

    link.addEventListener('click', this.closeFilter.bind(this));
    link.addEventListener('keyup', (e) => {
      if (e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.closeFilter(e);
      }
    });
  }

  closeFilter(e) {
    e.preventDefault();
    const form = this.closest('section-filter-form') || document.querySelector('section-filter-form');
    if (form) {
      form.form.reset();
      form.showAllSections();
    }
  }
}

customElements.define('section-facet-remove', SectionFacetRemove);
